import type { Chart } from 'chart.js/auto';
import { interfaceFontFamily, interfaceFontSize, interfaceLineHeight } from './typography';

/** Canvas text does not inherit body CSS. Keep charts in sync with UI language. */
export function watchChartTypography(charts: Pick<typeof Chart, 'defaults' | 'instances'>, doc: Document = document) {
  let family = '';
  const redraw = () => (Object.values(charts.instances) as Chart[]).forEach(chart => chart.update('none'));
  const update = () => {
    const language = doc.documentElement.lang || 'en';
    const next = interfaceFontFamily(language);
    if (next === family) return;
    family = next;
    charts.defaults.font.family = next;
    charts.defaults.font.size = interfaceFontSize(language) - 2;
    charts.defaults.font.lineHeight = interfaceLineHeight(language);
    redraw();
  };
  const observer = new MutationObserver(update);
  observer.observe(doc.documentElement, {attributes: true, attributeFilter: ['lang']});
  doc.fonts?.addEventListener('loadingdone', redraw);
  update();
  return () => {
    observer.disconnect();
    doc.fonts?.removeEventListener('loadingdone', redraw);
  };
}
